import type { ToolOutput } from '../../services/api'
import ChartMessage from './ChartMessage'
import TableMessage from './TableMessage'
import MetricCard from './MetricCard'

interface ToolOutputRendererProps {
  outputs: ToolOutput[]
}

/**
 * The outputs an answer carries — metrics first, then charts, tables and text —
 * each drawn by its design-system component. Spacing is the container's: a
 * source card's body or a message's attachments.
 */
const ToolOutputRenderer = ({ outputs }: ToolOutputRendererProps) => {
  if (!outputs || outputs.length === 0) {
    return null
  }

  const metricCards = outputs.filter((o) => o.type === 'metric_card')
  const otherOutputs = outputs.filter((o) => o.type !== 'metric_card')

  return (
    <>
      {metricCards.map((output, index) => (
        <MetricCard key={`metric-${index}`} output={output} />
      ))}

      {otherOutputs.map((output, index) => {
        switch (output.type) {
          case 'chart':
            return <ChartMessage key={`chart-${index}`} output={output} />
          case 'table':
            return <TableMessage key={`table-${index}`} output={output} />
          case 'text':
            return (
              <p key={`text-${index}`} className="t-small">
                {output.content}
              </p>
            )
          default:
            return null
        }
      })}
    </>
  )
}

export default ToolOutputRenderer
